import { handleActions } from '@housinganywhere/safe-redux';

import { SuggestionBarActionTypes } from '../constants';
import { Actions } from '../actions/suggestionBar';

export interface SuggestionBarState {
  isVisible: boolean;
  shownOnce: boolean;
}

export const initialState: SuggestionBarState = {
  isVisible: false,
  shownOnce: false,
};

const reducer = handleActions<
  SuggestionBarState,
  SuggestionBarActionTypes,
  Actions
>(
  {
    [SuggestionBarActionTypes.SHOW_SUGGESTION_BAR]: state =>
      state.shownOnce
        ? state
        : {
            ...state,
            isVisible: true,
            shownOnce: true,
          },
    [SuggestionBarActionTypes.HIDE_SUGGESTION_BAR]: state => ({
      ...state,
      isVisible: false,
    }),
  },
  initialState,
);

export const isVisible = (state: SuggestionBarState) => state.isVisible;

export default reducer;
